import { render } from "./VoteForTeam.vue?vue&type=template&id=01390610"
import script from "./VoteForTeam.vue?vue&type=script&lang=js"
export * from "./VoteForTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__